export default __webpack_public_path__ + "static/christina-wocintechchat-com-6Dv3pe-JnSg-unsplash-6597400e668f35758d895e41959d7423.jpg";